import { PredefinedViewConfig, SectionViewTypeEnum } from '../../../types'
import { OnlineFixedPageEnum } from '../../pages'

export enum PredefinedViewEnum {
  Home = 'home',
  SystemHardware = 'system-hardware',
  Energy = 'energy',
  OnlineSavingsCurrentNow = 'current-savings-now',
  OnlineSavingsCurrentFuture = 'current-savings-future',
  OnlineSavingsCurrentCumulative = 'current-savings-cumulative',
  ElectrifiedSavings = 'electrified-savings',
  Checkout = 'checkout',
  Disclaimer = 'disclaimer',
  // Deprecating, leave here for supporting legacy templates
  Savings = 'savings', // Deprecated
}

export const AVAILABLE_PREDEFINED_VIEWS: string[] = Object.values(PredefinedViewEnum)

const LEGACY_PREDEFINED_VIEW_AND_PAGES_ID = {
  [PredefinedViewEnum.Savings]: [
    OnlineFixedPageEnum.OnlineSavingsCurrentNow,
    OnlineFixedPageEnum.OnlineSavingsCurrentFuture,
    OnlineFixedPageEnum.OnlineSavingsCurrentCumulative,
    OnlineFixedPageEnum.OnlineSavingsElectrifiedNow,
    OnlineFixedPageEnum.OnlineSavingsElectrifiedFuture,
    OnlineFixedPageEnum.OnlineSavingsElectrifiedCumulative,
  ],
}

export const PREDEFINED_VIEW_AND_PAGES_ID: { [key in PredefinedViewEnum]: OnlineFixedPageEnum[] } = {
  [PredefinedViewEnum.Home]: [OnlineFixedPageEnum.OnlineHomeCurrent, OnlineFixedPageEnum.OnlineHomeElectrified],
  [PredefinedViewEnum.SystemHardware]: [OnlineFixedPageEnum.OnlineHomeSystem],
  [PredefinedViewEnum.Energy]: [OnlineFixedPageEnum.OnlineEnergy],

  [PredefinedViewEnum.OnlineSavingsCurrentNow]: [OnlineFixedPageEnum.OnlineSavingsCurrentNow],
  [PredefinedViewEnum.OnlineSavingsCurrentFuture]: [OnlineFixedPageEnum.OnlineSavingsCurrentFuture],
  [PredefinedViewEnum.OnlineSavingsCurrentCumulative]: [OnlineFixedPageEnum.OnlineSavingsCurrentCumulative],
  [PredefinedViewEnum.ElectrifiedSavings]: [
    OnlineFixedPageEnum.OnlineSavingsElectrifiedNow,
    OnlineFixedPageEnum.OnlineSavingsElectrifiedFuture,
    OnlineFixedPageEnum.OnlineSavingsElectrifiedCumulative,
  ],
  [PredefinedViewEnum.Disclaimer]: [OnlineFixedPageEnum.OnlineGoDisclaimers],
  [PredefinedViewEnum.Checkout]: [OnlineFixedPageEnum.OnlineGoCheckout],
  // Deprecating, leave here for supporting legacy templates
  ...LEGACY_PREDEFINED_VIEW_AND_PAGES_ID,
}

export const PREDEFINED_VIEW_AND_PAGES_CONFIGS = Object.entries(PREDEFINED_VIEW_AND_PAGES_ID).reduce((acc, cur) => {
  const view = cur[0]
  const pageIds = cur[1]

  acc[view] = {
    type: SectionViewTypeEnum.PredefinedViews,
    displayConditions: [],
    name: view,
    views: pageIds.map((pageId) => ({
      displayConditions: [],
      pageId,
    })),
  }
  return acc
}, {} as { [key in PredefinedViewEnum]: PredefinedViewConfig })
